export enum CompanyUserStatus {
  unknown = 'Unknown',
  invited = 'Invited',
  active = 'Active',
  inviteExpired = 'InviteExpired',
  deleted = 'Deleted',
}
